const translations = {
  "en": {
    "and": "and",
    "By registering, you accept our": "By registering, you accept our",
    "Privacy Policy": "Privacy Policy",
    "Terms of Use": "Terms of Use"
  },
  "zh-tw": {
    "and": "和",
    "By registering, you accept our": "註冊即表示你接受我們的",
    "Privacy Policy": "隱私權政策",
    "Terms of Use": "使用條款"
  }
};

export default translations;
